import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isRequesting: false,
    error: null,
    // Danh sách lệnh vận chuyển điện tử
    data: [],
    total: 0,
    searchCriteria: {}, // filter lệnh vận chuyển chưa xác nhận
    extra: {},

    // Chi tiết lệnh vận chuyển điện tử
    dataDetails: [],
    totalDetails: 0,
    searchCriteriaDetails: {}, // filter lệnh vận chuyển chưa xác nhận

    dataReport: [],
};
const slice = createSlice({
    name: 'transportOrderElec',
    initialState: initialState,
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action?.payload?.data || [],
                total: action?.payload?.total || 0,
                extra: action?.payload?.extra || {},
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
        summary_confirm: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        summary_resign: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        summary_resend: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        detail_resign: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        detail_resend: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        summary_confirm_success: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        summary_confirm_false: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        details_save: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        get_details_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteriaDetails: { ...action.payload },
            };
        },
        get_details_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                dataDetails: action?.payload?.data || [],
                totalDetails: action?.payload?.total || 0,
            };
        },
        get_details_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
            };
        },
        request_export_success: (state) => {
            const { export: exportData, ...restSearchCriteria } = state.searchCriteria;
            return {
                ...state,
                isRequesting: false,
                searchCriteria: {
                    ...restSearchCriteria,
                },
            };
        },
        request_export_details_success: (state) => {
            const { export: exportData, ...restSearchCriteria } = state.searchCriteriaDetails;
            return {
                ...state,
                isRequesting: false,
                searchCriteriaDetails: {
                    ...restSearchCriteria,
                },
            };
        },
        reset_state: (state) => {
            return {
                ...initialState,
                typeActive: state.typeActive,
            };
        },
        get_list_report: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
            };
        },
        get_list_report_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                dataReport: action?.payload?.data || [],
            };
        },
        get_list_report_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                dataReport: [],
            };
        },
        operator_confirm: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        operator_confirm_success: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        operator_confirm_false: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        confirm_not_accepted: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        confirm_not_accepted_success: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        confirm_not_accepted_failed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        // Kiểm tra sản lượng vé
        sync_ticket_quantity: (state) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
            };
        },
        sync_ticket_quantity_success: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        sync_ticket_quantity_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload?.error,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
